export default __webpack_public_path__ + "static/media/userpicMale.1fb7eff2.svg";